import { gql } from '@src/__generated__';

export const GET_QUESTIONS = gql(`
  query AllQuestions {
    findQuestions {
      choices {
        id
        directions
        text
        subtext
        thumbnailFilename
        layerQuestionId
      }
      parentChoice {
        id
        questionId
        text
        thumbnailFilename
      }
      id
      type
      directions
      text
      subtext
      thumbnailFilename
    }
  }
`);
// singleQuestion(id: ID!): Question!
export const GET_QUESTION = gql(`
  query Questions($id: ID!) {
    singleQuestion(id: $id) {
      id
      choices {
        id
      }
    }
  }
`);
